import React from "react";
import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon";

const PO28Button7Icon = (props: SvgIconProps) => (
  <SvgIcon fillRule="evenodd" clipRule="evenodd" color="secondary" fontSize="small" {...props}>
    <path d="M18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02943 4.02944 0 9 0C13.9706 0 18 4.02943 18 9ZM7.5 9.25C7.5 10.4926 6.49264 11.5 5.25 11.5C4.00736 11.5 3 10.4926 3 9.25C3 8.00735 4.00736 7 5.25 7C6.49264 7 7.5 8.00735 7.5 9.25ZM13.25 11.5C14.4926 11.5 15.5 10.4926 15.5 9.25C15.5 8.00735 14.4926 7 13.25 7C12.0074 7 11 8.00735 11 9.25C11 10.4926 12.0074 11.5 13.25 11.5Z" />
  </SvgIcon>
);

export default PO28Button7Icon;
